import { Button } from '@design-system/components/button/button';
import { Modal, PlainModalProps } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

type EducationCloseConfirmationModalProps = Pick<
  PlainModalProps,
  'isOpen' | 'onClose'
> & {
  confirmClose: () => void;
};

export const EducationCloseConfirmationModal = ({
  isOpen,
  onClose,
  confirmClose,
}: EducationCloseConfirmationModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Closing?"
    modalClassName="w-full md:w-[510px] md:h-[210px]"
    centerContent
  >
    <div className="flex flex-col gap-6">
      <Typography>
        Closing this may mean missing key insights to help you start earning
        quickly and make the most of Playbook.
      </Typography>
      <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
        <Button
          color="neutral"
          variant="text"
          className="w-[210px]"
          onClick={confirmClose}
        >
          Close anyway
        </Button>
        <Button color="neutral" className="w-[210px]" onClick={onClose}>
          Continue learning
        </Button>
      </div>
    </div>
  </Modal>
);
